/** @jsx h */
/** @jsxFrag Fragment */

import { h, Fragment } from "preact";

import { FormAction } from "./formReducer";
import {
  BasicFormEvent,
  FormFieldInputType,
  FormPage,
  FormValue,
  BodyPage as BodyPageData,
  IntroPage as IntroPageData,
  FinishPage as FinishPageData,
  FormState,
  FieldRecord,
} from "./FormTypes";
import { FormContent, FormInput } from "./components";
import { isContentBlock, isQuestionBlock } from "./utils/typePredicates";
import { ThunkDispatch } from "./utils/thunkReducer";

type FormFieldElement =
  | HTMLInputElement
  | HTMLSelectElement
  | HTMLTextAreaElement;

const valueFromEvent = (
  inputType: FormFieldInputType,
  event: BasicFormEvent
): FormValue => {
  if (event.target instanceof HTMLInputElement) {
    if (inputType !== "multi-select" && event.target.type === "checkbox") {
      return event.target.checked;
    }
  }
  return (event.target as FormFieldElement).value;
};

const handleInputEvent = (
  dispatch: ThunkDispatch<FormState, FormAction>,
  inputType: FormFieldInputType,
  event: BasicFormEvent
) => {
  const value = valueFromEvent(inputType, event);

  return dispatch({
    type: "inputChange",
    name: (event.target as FormFieldElement).name,
    value,
  });
};

export type BodyPageProps = {
  fields: FieldRecord;
  dispatch: (action: FormAction) => void;
  handleValidate: () => void;
  currentPage: BodyPageData | IntroPageData | FinishPageData;
  pages: FormPage[];
  isHeadingPage?: boolean;
};
export const BodyPage = ({
  currentPage,
  dispatch,
  handleValidate,
  fields,
  isHeadingPage,
}: BodyPageProps) => {
  const firstTextContentIdx = currentPage.blocks.findIndex(
    (b) => b.block_type === "text_content"
  );
  return (
    <>
      <form onSubmit={(event) => event.preventDefault()}>
        <fieldset>
          {currentPage.blocks.map((b, idx) => {
            if (isQuestionBlock(b)) {
              const field = fields[b.id];
              return (
                <FormInput
                  key={b.id}
                  {...b}
                  {...field}
                  onChange={(event) =>
                    handleInputEvent(dispatch, field.input_type, event)
                  }
                  onFocus={() =>
                    dispatch({ type: "focusField", key: field.field_key })
                  }
                  onBlur={handleValidate}
                  dispatch={dispatch}
                  showError={field.status === "invalid"}
                />
              );
            } else if (isContentBlock(b)) {
              return (
                <FormContent
                  key={b.id}
                  isHeading={isHeadingPage && firstTextContentIdx === idx}
                  {...b}
                />
              );
            }
          })}
        </fieldset>
      </form>
    </>
  );
};
